import fileDown from '../../../../../assets/logos/download_green.svg';
import { Card, Image } from 'react-bootstrap';
import { timestampToDate } from '../../Allotment/Allotment.controller';
import { downloadPaymentReceipt } from '../../EstateManagement.controller';

export const PaymentStatus = ({ transactionDetails, paymentColumns, paymentRowData }: any) => {
    return (
        <Card style={{ boxShadow: '0px 4px 24px 0px #0000001f', borderRadius: '22px', border: 'none' }}>
            <Card.Body>
                <div className='payment-done'>
                    <div className='row ps-3 pt-3'>
                        <div className='details ps-2 col-12'>
                            <div className='detail col-3'>
                                <div className='head'>Transaction ID</div>
                                <div className='content'>{transactionDetails?.payment?.transactionNumber || transactionDetails?.txnId || '-'}</div>
                            </div>
                            <div className='detail col-3'>
                                <div className='head'>Status</div>
                                <div className={`content pill ${transactionDetails?.payment?.transactionNumber || transactionDetails?.txnId ? 'pill-success' : 'pill-error'}`}>
                                    {transactionDetails?.payment?.transactionNumber || transactionDetails?.txnId || transactionDetails?.auditDetails?.createdTime ? 'Paid' : 'Not Paid'}
                                </div>
                            </div>
                            <div className='detail col-3'>
                                <div className='head'>Payment Date</div>
                                <div className='content'>{timestampToDate(transactionDetails?.auditDetails?.createdTime)}</div>
                            </div>
                            {transactionDetails?.invoiceRefId ? (
                                <div className='detail col-3'>
                                    <div className='head'>Receipt</div>
                                    <div className='content link d-flex gap-1 align-items-center' onClick={() => downloadPaymentReceipt(transactionDetails?.invoiceRefId)}>
                                        <Image src={fileDown} height={20} />
                                        Download
                                    </div>
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};
